import React from 'react';
import { Container, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from '@mui/material';

const RSVPList = () => {
  const events = [
    { name: 'Event 1', date: '12/12/1212', totalRSVP: 100, status: 'Active' },
    { name: 'Event 2', date: '12/12/1212', totalRSVP: 10, status: 'Active' },
    { name: 'Event 3', date: '10/2/2024', totalRSVP: 33, status: 'Cancelled' },
    { name: 'Event 4', date: '11/11/2022', totalRSVP: 11, status: 'Completed' },
    { name: 'Event 5', date: '22/3/2025', totalRSVP: 50, status: 'Draft' },
  ];

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        RSVP List
      </Typography>
      <Typography variant="h6" gutterBottom>
        Event List
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox />
              </TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Total RSVP ↑</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event, index) => (
              <TableRow key={index}>
                <TableCell padding="checkbox">
                  <Checkbox />
                </TableCell>
                <TableCell>{event.name}</TableCell>
                <TableCell>{event.date}</TableCell>
                <TableCell>{event.totalRSVP}</TableCell>
                <TableCell>{event.status}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default RSVPList;